export const CATEGORY_COURSES_REQUEST = "CATEGORY_COURSES_REQUEST";
export const CATEGORY_COURSES_SUCCESS = "CATEGORY_COURSES_SUCCESS";
export const CATEGORY_COURSES_FAIL = "CATEGORY_COURSES_FAIL";

export const GET_COURSE_SUBJECTS_REQUEST = "GET_COURSE_SUBJECTS_REQUEST";
export const GET_COURSE_SUBJECTS_SUCCESS = "GET_COURSE_SUBJECTS_SUCCESS";
export const GET_COURSE_SUBJECTS_FAIL = "GET_COURSE_SUBJECTS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
